import React from 'react';
import { Mail, Phone, MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-orange-500">
              Shanghai RunTheRays Int. Trade Co. Ltd.
            </h3>
            <p className="text-gray-300 mb-4">
              Global Trade Made Simple. Reliable. Transparent.
            </p>
            <p className="text-gray-400 text-sm">
              Since 2019, empowering businesses worldwide to trade confidently with China.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-orange-500 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-sm text-gray-400">Email</p>
                  <a href="mailto:operation-rep@runtheraysintl.com" className="text-white hover:text-orange-500 transition-colors duration-200 block">
                    operation-rep@runtheraysintl.com
                  </a>
                  <a href="mailto:info@runtheraysintl.com" className="text-white hover:text-orange-500 transition-colors duration-200 block">
                    info@runtheraysintl.com
                  </a>
                  <a href="mailto:sourcing@runtheraysintl.com" className="text-white hover:text-orange-500 transition-colors duration-200 block">
                    sourcing@runtheraysintl.com
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-orange-500 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-sm text-gray-400">China</p>
                  <p className="text-white">+86 198 2182 9731</p>
                  <p className="text-white">+86 131 6605 7223</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MessageCircle className="w-5 h-5 text-orange-500 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-sm text-gray-400">WhatsApp</p>
                  <p className="text-white">+233 544 205 844</p>
                  <p className="text-white">+86 131 6605 7223</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Commitment</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-start">
                <span className="text-orange-500 mr-2">✓</span>
                <span>Rigorous quality standards</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-2">✓</span>
                <span>Fast, transparent communication</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-2">✓</span>
                <span>Ethical business practices</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-2">✓</span>
                <span>Unwavering dedication to success</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Shanghai RunTheRays International Trade Co., Ltd. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mt-2">
            Your success is our reputation.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;